import { useForm, useFieldArray, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { allocateChart } from "../../../services/managerWorkListService";
import { fetchAvailableAllocation } from "../../../services/managerWorkListService";
import { useEffect, useState } from "react";
import Select from "react-select";
import "../ManagerWorklistDetails.css";
import * as yup from "yup";
import React from "react";
import CountUp from "react-countup";

let isValidschema = yup.object().shape({
  list: yup.array().of(
    yup.object().shape({
      from: yup
        .number("Must be a number")
        .typeError("Must be a number")
        .min(1, "Must be greater than 0")
        .required("Required"),
      to: yup
        .number("Must be a number")
        .typeError("Must be a number")
        .min(yup.ref("from"), "Must be equal to or greater than From value"),
      userId: yup.object().shape({
        label: yup.string().required("Required"),
        value: yup.string().required("Required"),
      }),
    }),
  ),
});

function WorkilstAllocateFreshVolume({
  masterData,
  worklistId,
  setParentDetails,
  onQuery,
  changeInWorklist,
  setChangeInWorklist,
}) {
  const [volAvailable, setVolAvailable] = useState();
  const [resultSet, setResultSet] = useState();
  const [isLoading, setLoadingState] = useState(false);

  useEffect(() => {
    getAvailableAllocation();
  }, [resultSet]);

  const getAvailableAllocation = async () => {
    const res = await fetchAvailableAllocation(worklistId);
    setVolAvailable(res);
  };

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      list: [{ from: "", to: "", userId: "" }],
    },
    mode: "onChange",
    resolver: yupResolver(isValidschema),
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "list",
  });

  const onSave = async (data) => {
    setLoadingState(true);

    data = {
      list: data.list.map((item) => {
        return { ...item, userId: item?.userId?.value };
      }),
    };

    let resp = await checkRangeOverlapfunction(data.list);

    if (resp === "true") {
      const res = await allocateChart(data, worklistId);
      setResultSet(res);
      onQuery(res);
      if (res.success === true) {
        setChangeInWorklist(!changeInWorklist);
        reset({
          list: [{ from: "", to: "", userId: "" }],
        });
      }
      setParentDetails(data);
      setLoadingState(false);
    } else {
      document.getElementById("overlapping_id").innerHTML =
        "Overlapping Ranges Found";
      setTimeout(function () {
        document.getElementById("overlapping_id").innerHTML = "";
      }, 4000);
      setLoadingState(false);
    }
  };

  const checkRangeOverlapfunction = async (arr) => {
    var err = false;
    arr.forEach(function (r1, i1) {
      arr.forEach(function (r2, i2) {
        if (r2 !== r1) {
          if (r1.from >= r2.from && r1.from <= r2.to) {
            err = true;
          }
          if (r1.to >= r2.from && r1.to <= r2.to) {
            err = true;
          }
        }
      });
    });
    if (err) {
      return "false";
    } else {
      return "true";
    }
  };

  const handleReset = () => {
    reset({
      list: [{ from: "", to: "", userId: "" }],
    });
  };

  const renderUserId = () => {
    let coders = [];

    masterData?.coders_all?.forEach((data) => {
      coders.push({
        // Active Coders
        label: data.name,
        value: data.id,
      });
    });

    return coders;
  };

  return (
    <>
      <div className="col-xl-5">
        <div className="card card-flush mb-6 mb-xl-9 card1">
          <div className="card-header py-4">
            <p className="card-title align-items-start flex-column">
              <span className="fw-bold h4">Allocate Fresh Volume</span>
              <span className="text-gray-400 mt-1 fw-semibold fs-6">
                Select serial numbers &amp; user to assign volume
              </span>
            </p>
          </div>
          <div className="card-body pt-0 pb-5">
            <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-4 pb-2">
              <span className="svg-icon svg-icon-2tx svg-icon-danger me-4">
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.3"
                    d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                    fill="currentColor"
                  />
                  <path
                    d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z"
                    fill="currentColor"
                  />
                </svg>
              </span>
              <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                <div className="mb-3 mb-md-0 fw-semibold">
                  <h4 className="text-gray-900 fw-bold mb-0">
                    Volume available for allocation
                  </h4>
                  <div className="d-flex  content-justify-center flex-row-fluid">
                    <div className="d-flex fw-semibold align-items-center my-3">
                      {volAvailable?.s_no_ranges?.map((item, index) => (
                        <React.Fragment key={index}>
                          <div className="bg-default me-3">
                            <i className="fa fa-check" />
                          </div>
                          <div className="text-gray-700 flex-grow-1 me-4">
                            {item}
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </div>
                <div className=" text-center  rounded me-3">
                  <span
                    className="fs-2hx fw-bold text-danger counted"
                    data-kt-countup="true"
                    data-kt-countup-value={volAvailable?.remaining_count}
                    data-kt-initialized={1}
                  >
                    <CountUp
                      start={0}
                      end={volAvailable?.remaining_count}
                    ></CountUp>
                  </span>
                  <span className="fs-4 fw-semibold text-gray-700 d-block">
                    Remaining
                  </span>
                </div>
              </div>
            </div>
            {volAvailable?.remaining_count !== 0 && (
              <form className="form" onSubmit={handleSubmit(onSave)}>
                <div className="form-group">
                  {fields.map((field, index) => (
                    <div
                      data-repeater-list="kt_ecommerce_add_product_options"
                      className=""
                      key={field.id}
                    >
                      <div className="form-group row">
                        <div className="col-lg-3 col-md-3 col-12 mb-3">
                          <input
                            min={1}
                            type="number"
                            className="form-control"
                            name="from"
                            placeholder="From"
                            {...register(`list.${index}.from`)}
                          />
                          {errors?.list?.[index]?.from && (
                            <span className="error-color">
                              {errors?.list?.[index]?.from.message}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-3 col-md-3 col-12 mb-3">
                          <input
                            min={1}
                            type="number"
                            className="form-control"
                            name="to"
                            placeholder="To"
                            {...register(`list.${index}.to`)}
                          />
                          {errors?.list?.[index]?.to && (
                            <span className="error-color">
                              {errors?.list?.[index]?.to.message}
                            </span>
                          )}
                        </div>
                        <div className="col-lg-5 col-md-5 col-12 mb-3">
                          <div className=""></div>
                          <Controller
                            name={`list.${index}.userId`}
                            control={control}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={renderUserId()}
                                menuPlacement="auto"
                              />
                            )}
                          />
                          {errors?.list?.[index]?.userId && (
                            <span className="error-color">{"Required"}</span>
                          )}
                        </div>
                        {fields.length !== 1 && (
                          <button
                            onClick={() => remove(index)}
                            className="btn btn-sm btn-icon btn-light-danger delete-row mobile-delete-row"
                          >
                            <span className="svg-icon svg-icon-1">
                              <svg
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <rect
                                  opacity="0.5"
                                  x="7.05025"
                                  y="15.5356"
                                  width={12}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-45 7.05025 15.5356)"
                                  fill="currentColor"
                                />
                                <rect
                                  x="8.46447"
                                  y="7.05029"
                                  width={12}
                                  height={2}
                                  rx={1}
                                  transform="rotate(45 8.46447 7.05029)"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  className="d-flex flex-stack mt-10 pt-5 bs-red-error "
                  id="overlapping_id"
                ></div>
                <div className="d-flex flex-stack mt-10 pt-5 border-top">
                  <button
                    type="button"
                    className="btn btn-sm btn-light"
                    onClick={() => append({ from: "", to: "", userId: "" })}
                  >
                    <span className="svg-icon svg-icon-2">
                      <svg
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          opacity="0.5"
                          x={11}
                          y={18}
                          width={12}
                          height={2}
                          rx={1}
                          transform="rotate(-90 11 18)"
                          fill="currentColor"
                        />
                        <rect
                          x={6}
                          y={11}
                          width={12}
                          height={2}
                          rx={1}
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    Add another
                  </button>
                  <div className="text-left">
                    <button
                      type="reset"
                      id="kt_modal_new_card_cancel"
                      className="btn btn-sm btn-light ms-3"
                      onClick={handleReset}
                    >
                      Clear
                    </button>
                    <button
                      type="submit"
                      className="btn btn-sm btn-primary"
                      disabled={isLoading}
                    >
                      <span className="indicator-label">
                        {isLoading ? "Please wait..." : "Save"}
                      </span>
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default WorkilstAllocateFreshVolume;
